import { dequal } from 'dequal/lite'

const isEqual = dequal

export default isEqual
